import React from "react";
import InfoCard from "~/components/InfoCard";
import AlertComponent from "~/components/AlertComponent";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const InfosComponent = ({
  images,
  onClick,
  onDelete,
  handleOnDragEnd,  
  onView,
  onDownload
}) => {
  return (
    <>  
      <div className="content content-xs">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="images">
            {(provided) => (
              <ul {...provided.droppableProps} ref={provided.innerRef} style={{padding: "0px"}}> 
                {images?.map((item, index) => {
                  return (       
                    <Draggable key={item.imageId.toString()} draggableId={item.imageId.toString()} index={index}>
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                          <InfoCard     
                            showTime={item.showTime}
                            name={item.noticeTitle}
                            id={item.imageId}
                            index={index}
                            onClick={() => {
                              onClick(item.imageId);
                            }}
                            onDelete={() => {
                              AlertComponent.dialog("Irá apagar o informativo.",
                                function dialoagNo() {
                                },
                                function dialoagYes() {
                                  onDelete(item.imageId);
                                }    
                              );
                            }}
                            onView={() => {
                              onView(item.imageId);
                            }}
                            onDownload={() => {
                              onDownload(item.imageId);
                            }}
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>        
      </div>
    </>
  );
};

export default InfosComponent;
